let docLinks = {
  py: 'https://cmap.readthedocs.io/en/latest/user_guide/API_ref/pycmap_api/pycmap_api_ref.html',
  r: 'https://simonscmap.github.io/cmap4r/index.html',
  julia:
    'https://cmap.readthedocs.io/en/latest/user_guide/API_ref/juliacmap_api/juliacmap_api_ref.html',
  matlab:
    'https://cmap.readthedocs.io/en/latest/user_guide/API_ref/matcmap_api/matcmap_api_ref.html',
};

export default docLinks;
